<template>
    <div :class="cssClass" class="disabled-message"><p><b>NOTE</b><span>{{ message }}</span></p></div>
</template>

<script>
export default {
    name: "DisabledMessage",
    props: {
        cssClass: {
            type: [Object, String],
            default: ""
        },
        message: {
            type: String,
            required: true
        }
    }
}
</script>
